import React, { useEffect, useState, } from "react";
import { makeStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Switch,
  IconButton,
  Typography
} from "@material-ui/core";
import QueueIcon from "@material-ui/icons/FormatListBulleted";
import {useTranslation} from "react-i18next";


const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-root": {
      margin: theme.spacing(1),
    },
  },
  btnDiv: {
    display: 'flex',
    padding: theme.spacing(2), 
    width:"78%",
    justifyContent:'center',

  },
  button: {

    width:"78%",
    margin: "5px",
    backgroundColor:'#0288d1'

  },
}));

export default function QueuesDialog(props) {
  const {t} = useTranslation();
    //console.log("Inside Dialog");
    //console.log(props);
    const classes = useStyles();
    //const { onClose, state, open } = props;
    const groupState = [...props.state];
    const [isChecked,setChecked] = useState([...groupState])
   
    useEffect(()=>{
            setChecked([...groupState]);
            //console.log("Group Set in UseEffect");
    },[props.open]);

    const handleClose = () => {
      props.onClose(isChecked);
    };
    
    const handleSwitchChange = (event) => {
        groupState[event.target.name].IsAvailable = event.target.checked;
        setChecked([...groupState]);
        //console.log(isChecked);
        //onClose(value);
    };
       
    return (
        <Dialog onClose={handleClose} aria-labelledby="dialog-title" open={props.open} fullWidth maxWidth="xs" className={classes.root}>
        <DialogTitle id="dialog-title" style={{textAlign:'center'}}>
        <IconButton>
            <QueueIcon fontSize="large" style={{color:"#0288d1"}}/>
          </IconButton>
        <Typography variant="h5" style={{color:"#0288d1"}}>
        {t('queuedialog.agentqueues')}
        </Typography>
        </DialogTitle>
        <FormControl component="fieldset" style={{alignItems:'center'}}>
            <FormGroup>
               {isChecked.map((group,index)=> (
                <Typography component="div" style={{display:'flex', justifyContent:'space-between'}}>
                <span style={{paddingRight:'2em'}}>{group.Name}</span>
                <Switch checked={group.IsAvailable} onChange={handleSwitchChange} name={index}/>
                </Typography>
                ))}
            </FormGroup>
            <div className={classes.btnDiv}>
            <Button variant="contained" color="primary" onClick={()=>{props.onClose(isChecked)}} className={classes.button}>{t('queuedialog.save')}</Button>
            <Button variant="contained" color="primary" onClick={()=>{props.onClose(null)}} className={classes.button}>{t('queuedialog.close')}</Button>
            </div>
        </FormControl>
        </Dialog>
    );
}